import { useState } from 'react'
import { getClassNameForField, religiousDuesFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaEye, FaTrash } from 'react-icons/fa'
import { FaEyeSlash } from 'react-icons/fa6'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import ReligiousDuesSlug from '../../public/pages/ReligiousDuesSlug'
import { useTranslationService } from '../../util/TranslationContext'
import { useTranslation } from 'react-i18next'

const ReligiousDuesSlugAdmin = () => {
    const [showConfirm, setShowConfirm] = useState(false)
    const { id } = useParams()
    const { t } = useTranslation()

    const { translateFields } = useTranslationService()
    const religiousDuesFields = translateFields(fields, 'religious_dues')

    const deleteItem = useDeleteItem()
    const handleDelete = async () => {
        await deleteItem({
            url: `admin/religious-dues/${id}`,
            navigateSuccess: '/admin/auth/religious-dues',
            onError: msg => alert(msg),
        })
    }

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button
                    variant='primary'
                    className='mb-4'
                    onClick={() =>
                        window.open(`/religious-dues/${id}`, '_blank', 'noopener,noreferrer')
                    }
                >
                    {' '}
                    <FaEye /> {t('status.preview')}
                </Button>
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash /> {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                />
            </div>
            <EditableFormPage
                fetchUrl={`admin/religious-dues/${id}?_method=PUT`}
                fields={religiousDuesFields}
                classNameForField={getClassNameForField}
                errorMessage='Failed to fetch data.'
            />
        </>
    )
}

export default ReligiousDuesSlugAdmin
